<template>
  <main>
    <section v-if="pendingRequests.length" class="is-info panel">
      <h4 class="panel-heading">Pending Requests:</h4>
      <div
        v-for="pendingRequest in pendingRequests"
        :key="pendingRequest.id"
        class="panel-block"
      >
        <label for="pendingRequest"
          >{{ toProperCase(pendingRequest.userTo.username) }} requests ${{
            pendingRequest.amount.toFixed(2)
          }}</label
        >
        <div class="buttonHolder ml-3">
          <button
            class="button approve mr-2"
            v-on:click="approve(pendingRequest)"
          >
            Approve ✅
          </button>
          <button class="button reject" v-on:click="reject(pendingRequest)">
            Reject ❌
          </button>
        </div>
      </div>
    </section>
    <div v-show="response" style="margin: 10px">
      <article
        class="message"
        :class="{
          'is-success': message.toLowerCase().includes('success'),
          'is-danger': !message.toLowerCase().includes('success'),
        }"
      >
        <div class="message-header">
          <p>{{ responseHeader }}</p>
          <button
            class="delete"
            aria-label="delete"
            @click="
              response = false;
              cancel();
            "
          ></button>
        </div>
        <div class="message-body">
          {{ message }}
        </div>
      </article>
    </div>
  </main>
</template>

<script>
import transferService from "../services/TransferService";
import accountService from "../services/AccountService";

export default {
  name: "pending-requests",
  data() {
    return {
      forceRefresh: true,
      message: "",
      response: false,
      responseHeader: "",
    };
  },
  computed: {
    pendingRequests() {
      return this.$store.state.transactions.filter(
        (tx) =>
          tx.transferStatus === "Pending" &&
          tx.userFrom.id === this.$store.state.user.id
      );
    },
  },
  methods: {
    approve(pendingRequest) {
      const transferInfo = {
        transferStatus: "Approved",
      };
      transferService
        .updateTransfer(pendingRequest.transferId, transferInfo)
        .then((response) => {
          if (response.status === 200) {
            this.message = "Successfully approved the request.";
            this.responseHeader = "Approved";
            this.response = true;
            pendingRequest.transferStatus = "Approved";
            pendingRequest.pending = false;
            pendingRequest.approved = true;
            this.refreshAll();
          } else {
            alert("Response wasn't 200 (Ok)");
          }
        })
        .catch((error) => {
          this.responseHeader = "Transfer failed!";
          this.message = error.response.data.message;
          this.response = true;
        });
    },
    reject(pendingRequest) {
      const transferInfo = {
        transferStatus: "Rejected",
      };
      transferService
        .updateTransfer(pendingRequest.transferId, transferInfo)
        .then((response) => {
          if (response.status === 200) {
            this.message = "Successfully rejected the request.";
            this.responseHeader = "Rejected";
            this.response = true;

            pendingRequest.transferStatus = "Rejected";
            pendingRequest.pending = false;
            pendingRequest.rejected = true;
            this.refreshAll();
          } else {
            alert("Response wasn't 200 (Ok)");
          }
        })
        .catch((error) => {
          this.responseHeader = "Transfer failed!";
          this.message = error.response.data.message;
          this.response = true;
        });
    },
    refreshAll() {
      this.refreshBalance();
      this.refreshTransfers();
    },
    refreshBalance() {
      accountService.getBalance().then((response) => {
        this.$store.commit("SET_BALANCE", response.data.balance);
      });
    },
    refreshTransfers() {
      accountService.getTransfers().then((response) => {
        this.$store.commit("SET_TRANSACTIONS", response.data);
      });
    },
    toProperCase(str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
  },
};
</script>

<!-- <style scoped>
.buttonHolder {
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
}

button {
    margin: 0 5px;
}

section {
    margin-top: 50px;
    margin-left: 15px;
}
</style> -->